const jigouguanli = { // 试题库
  path: 'jigouguanli',
  name: 'jigouguanli',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/xitongguanli/jigouguanli/jigouguanli_list'))
    }, 'jigouguanli')
  }
}
const dept = { // 试题库
  path: 'dept',
  name: 'dept',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/xitongguanli/dept/dept_list'))
    }, 'dept')
  }
}
const dict = { // 试题库
  path: 'dict',
  name: 'dict',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/xitongguanli/dict/dict_list'))
    }, 'dict')
  }
}
const log = { // 试题库
  path: 'operate-log',
  name: 'operate-log',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/xitongguanli/log/operate-log/operAteLog_list'))
    }, 'operate-log')
  }
}

const notice = { // 试题库
  path: 'notice',
  name: 'notice',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/xitongguanli/notice/notice_list'))
    }, 'notice')
  }
}
const post = { // 试题库
  path: 'post',
  name: 'post',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/xitongguanli/post/post_list'))
    }, 'post')
  }
}
const role = { // 试题库
  path: 'role',
  name: 'role',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/xitongguanli/role/role_list'))
    }, 'role')
  }
}
const course = { // 课程表
  path: 'course',
  name: 'course',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/xitongguanli/course/course_list'))
    }, 'course')
  }
}
const courseDetails = { // 课程表详情
  path: 'courseDetails/:id',
  name: 'courseDetails',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/xitongguanli/courseDetails/courseDetails_list'))
    }, 'courseDetails')
  }
}
export {
  jigouguanli,
  dept,
  role,
  post,
  notice,
  log,
  dict,
  course,
  courseDetails
}
